module.exports = __webpack_public_path__ + "img/refund.6ee95bea.svg";